export enum EStep {
    PROFILE = 0,
    QUALIFICATION = 1,
    PREVIEW = 2,
    FINISH = 3,
}
